module.exports = __webpack_public_path__ + "static/microsoft-certified-azure-fundamentals-931153f7c0ab4d74d47c2158fe319d4a.png";